import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { External } from '../../Link';
import { makeStyles } from '@material-ui/core/styles';
import { Headline, Paragraph } from './index';

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
}));
const MoreGoogleAnalytics = () => {
  const classes = useStyles();
  return (
    <Box mt={4}>
      <Headline>
        Servicebeschreibung
      </Headline>
      <Paragraph>
        Dies ist ein Webanalysedienst.
      </Paragraph>
      <Headline>
        Verarbeitendes Unternehmen
      </Headline>
      <Paragraph>
        Google Ireland Limited <br />
        Google Building Gordon House, 4 Barrow St,
        Dublin, D04 E5W5, Ireland
      </Paragraph>
      <Headline>
        Datenverarbeitungszwecke
      </Headline>
      <Paragraph>
        Diese Liste stellt die Zwecke der Datenerhebung und -verarbeitung dar.{' '}
        <br />
        - Marketing, Werbung, Web-Analytik
      </Paragraph>
      <Headline>
        Verwendete Technologien
      </Headline>
      <Paragraph>
        Diese Liste enthält alle Technologien, mit denen dieser Dienst Daten
        sammelt. Typische Technologien sind Cookies und Pixel, die im Browser
        platziert werden. <br />
        - Cookies, Pixel-Tags
      </Paragraph>
      <Headline>
        Erhobene Daten
      </Headline>
      <Paragraph>
        Diese Liste enthält alle (persönlichen) Daten, die von oder durch die
        Nutzung dieses Dienstes gesammelt werden.
        <br/>
        - IP-Adresse, Datum und Uhrzeit
        des Besuchs, Nutzungsdaten, Klickpfad, App-Updates,
        Browser-Informationen, Geräteinformation, JavaScript-Unterstützung,
        Besuchte Seiten, Referrer URL, Downloads, Flash-Version,
        Standortinformationen, Kaufaktivitäten, Widget-Interaktionen
      </Paragraph>
      <Headline>
        Rechtliche Grundlage
      </Headline>
      <Paragraph>
        Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung
        von Daten genannt.
        <br />
        - Art. 6 (1) (a) GDPR
      </Paragraph>
      <Headline>
        Ort der Verarbeitung
      </Headline>
      <Paragraph>
        Dies ist der primäre Ort, an dem die gesammelten Daten verarbeitet
        werden. Sollten die Daten auch in anderen Ländern verarbeitet werden,
        werden Sie gesondert informiert. <br />- Europäische Union
      </Paragraph>
      <Headline>
        Aufbewahrungsdauer
      </Headline>
      <Paragraph>
        Die Aufbewahrungsfrist ist die Zeitspanne, in der die gesammelten Daten
        für die Verarbeitung gespeichert werden. Die Daten müssen gelöscht
        werden, sobald sie für die angegebenen Verarbeitungszwecke nicht mehr
        benötigt werden.
        <br />- Die Daten werden gelöscht, sobald sie nicht mehr für die
        Verarbeitungszwecke benötigt werden.
      </Paragraph>
      <Headline>
        Weitergabe an Drittländer
      </Headline>
      <Paragraph>
        Dieser Service kann die erfassten Daten an ein anderes Land
        weiterleiten. Bitte beachten Sie, dass dieser Service Daten außerhalb
        der Europäischen Union und des europäischen Wirtschaftsraums und in ein
        Land, welches kein angemessenes Datenschutzniveau bietet, übertragen
        kann. Falls die Daten in die USA übertragen werden, besteht das Risiko,
        dass Ihre Daten von US-Behörden zu Kontroll- und Überwachungszwecken
        verarbeitet werden können, ohne dass Ihnen möglicherweise
        Rechtsbehelfsmöglichkeiten zustehen. Nachfolgend finden Sie eine Liste
        der Länder, in die die Daten übertragen werden. Dies kann für
        verschiedene Zwecke der Fall sein, z. B. zum Speichern oder Verarbeiten.{' '}
        <br />- Vereinigte Staaten von Amerika
      </Paragraph>
      <Headline>
        Datenempfänger
      </Headline>
      <Paragraph>
        Im Folgenden werden die Empfänger der erhobenen Daten aufgelistet.{' '}
        <br />- Alphabet Inc.
      </Paragraph>
      <Paragraph>
        <External
          target="_blank"
          className={classes.link}
          href="https://policies.google.com/privacy?hl=en"
        >
          Klicken Sie hier
        </External>
        , um die Datenschutzbestimmungen des Datenverarbeiters zu lesen. <br />
        <External
          target="_blank"
          className={classes.link}
          href="https://policies.google.com/technologies/cookies?hl=en"
        >
          Klicken Sie hier
        </External>
        , um die Cookie-Richtlinie des Datenverarbeiters zu lesen. <br />
        <External
          target="_blank"
          className={classes.link}
          href="https://safety.google/privacy/privacy-controls/"
        >
          Klicken Sie hier
        </External>
        , um auf allen Domains des verarbeitenden Unternehmens zu widerrufen.
      </Paragraph>
    </Box>
  );
};

export default MoreGoogleAnalytics;
